import { render, staticRenderFns } from "./ProviderAssociatedResourceTabs.vue?vue&type=template&id=6f7c2a54&scoped=true&"
import script from "./ProviderAssociatedResourceTabs.vue?vue&type=script&lang=js&"
export * from "./ProviderAssociatedResourceTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7c2a54",
  null
  
)

export default component.exports